import { useState, useEffect } from 'react'
import { getChains } from '@/services/api'
import type { Chain } from '@/types'

export function useChains() {
  const [chains, setChains] = useState<Chain[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchChains() {
      try {
        const data = await getChains()
        setChains(data)
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load chains')
      } finally {
        setLoading(false)
      }
    }

    fetchChains()
  }, [])

  return { chains, loading, error }
}
